import * as React from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';

import mainTheme from "../Themes";
import { TableSortLabel, Typography } from '@mui/material';

interface Column {
  id: string;
  label: string;
  align?: 'right' | 'left' | 'center';
}

interface BasicTableProps {
  columns: Column[];
  rows: { [key: string]: string | number }[];
  maxHeight: any;
  minWidth: any;
  order: 'asc' | 'desc';
  orderBy: string;
  onRequestSort: (property: string) => void;
}

const BasicTable: React.FC<BasicTableProps> = ({ columns, rows, maxHeight, minWidth, order, orderBy, onRequestSort }) => {
  const createSortHandler = (property: string) => () => {
    onRequestSort(property);
  };
  
  return (
    <TableContainer 
      component={Paper} 
      sx={{ maxHeight: maxHeight, overflowY: 'auto', overflowX: 'auto', boxShadow: 0, border: 1, borderColor: "#E6E6E6", width: '100%',
    maxWidth: '100%',
    boxSizing: 'border-box' }}  // Set maxHeight and enable scrolling
    >
      <Table stickyHeader sx={{ minWidth: minWidth, width: '100%', tableLayout: 'auto' }} aria-label="dynamic table">
        <TableHead>
          <TableRow style={mainTheme.tableStyle.header}>
            {columns.map((column) => (
              <TableCell
                key={column.id}
                align={column.align || 'left'}
                style={mainTheme.tableStyle.header}
              >
                <TableSortLabel
                  active={orderBy === column.id}
                  direction={orderBy === column.id ? order : 'asc'}
                  onClick={createSortHandler(column.id)}
                  style={column.align === 'right' ? { flexDirection: "row-reverse" } : { flexDirection: "row" }}
                >
                  <Typography style={mainTheme.tableStyle.header}>
                    {column.label}
                  </Typography>
                </TableSortLabel>
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.map((row, rowIndex) => (
            <TableRow
              key={rowIndex} 
              sx={{ '&:last-child td, &:last-child th': { border: 0 }, "&:hover": { backgroundColor: mainTheme.colors.innoGreenL + "30" }, }}
            >
              {columns.map((column) => (
                <TableCell
                  key={column.id}
                  align={column.align || 'left'} 
                  sx={{
                    //@ts-expect-error
                    backgroundColor: mainTheme.cell[`style-${column.id}`],
                    '.MuiTableRow-root:hover &': {
                      backgroundColor: `${mainTheme.colors.innoGreenL}30 !important`, // override cell style on hover
                    },
                  }}
                >
                  <Typography style={mainTheme.tableStyle.row}>
                    {
                      //@ts-expect-error
                      row.fieldData[column.id]
                    }
                  </Typography>
                </TableCell>
              ))}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}

export default BasicTable;
